import { render, staticRenderFns } from "./cdxf-record.vue?vue&type=template&id=63261b05&scoped=true&"
import script from "./cdxf-record.vue?vue&type=script&lang=js&"
export * from "./cdxf-record.vue?vue&type=script&lang=js&"
import style0 from "./cdxf-record.vue?vue&type=style&index=0&id=63261b05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63261b05",
  null
  
)

export default component.exports